<template>
  <v-row
    class="reload-and-loader-wrapper"
    no-gutters
  >
    <StLoader :loading="loading" />
    <div
      v-if="error"
      class="reload-and-loader-wrapper__error-message"
    >
      <StReloadOnError
        :failed-to-load-text="failedToLoadText"
        :reload-button-text="reloadButtonText"
        @reload="$emit('reload')"
      />
    </div>
    <span
      v-if="success"
      class="reload-and-loader-wrapper--success"
    >
      <slot name="wrappedComponent" />
    </span>
  </v-row>
</template>

<script>
import StLoader from '@stilingue/st-loader/StLoader';
import StReloadOnError from '@stilingue/st-reload-on-error/StReloadOnError';
import requestStatus from './request_status.mixin';

export default {
  name: 'StReloadAndLoaderWrapper',
  components: {
    StLoader,
    StReloadOnError
  },
  mixins: [requestStatus],
  props: {
    requestStatus: {
      type: String,
      required: true
    },
    failedToLoadText: {
      type: String,
      default: ''
    },
    reloadButtonText: {
      type: String,
      default: 'Recarregar'
    }
  }
};
</script>

<style scoped>
  .reload-and-loader-wrapper,
  .reload-and-loader-wrapper--success,
  .reload-and-loader-wrapper__error-message {
    width: 100%;
  }
</style>
